import * as React from "react";
import { Icon } from "@utdanningsdirektoratet/icon";
import { cls } from "@utdanningsdirektoratet/utils/cls";
import styles from "./Dropdown.module.less";

type DropdownItemProps = {
  selected?: boolean;
  closeOnClick?: boolean;
  disabled?: boolean;
  noIcon?: boolean;
  className?: string;
  onClick?: (e?: React.MouseEvent<HTMLButtonElement>) => void;
  children?: ((props: { className: string }) => React.ReactNode) | React.ReactNode;
};

const DropdownItem: React.FC<DropdownItemProps> = ({ children, selected, className, noIcon, onClick, closeOnClick, disabled }) => {
  const getIcon = (): React.ReactNode => {
    if (noIcon) return null;
    if (selected === undefined) {
      return <Icon onClick={(e: React.MouseEvent) => e.stopPropagation()} className={styles.dropdownListItemIcon} icon="angle right" />;
    }
    if (selected) {
      return <Icon onClick={(e: React.MouseEvent) => e.stopPropagation()} className={styles.dropdownListItemIcon} icon="check" />;
    }
    return null;
  };

  let content: React.ReactNode;

  if (typeof children === "function") {
    content = (children as (a: unknown) => React.ReactNode)({
      className: styles.dropdownListItemButton,
    });
  } else {
    content = (
      <button onClick={onClick} disabled={disabled} type="button" className={styles.dropdownListItemButton}>
        {children}
      </button>
    );
  }

  return (
    <li className={cls(styles.dropdownListItem, className)} data-closeonclick={closeOnClick}>
      {content}
      {getIcon()}
    </li>
  );
};

export default DropdownItem;
